(function ($) {
  $(document).ready(function ($) {
    if ($("html").hasClass("is-animating")) {
      $("html").removeClass("is-animating");
    }

    // Your site's jQuery goes inside this .ready() function.
    /*****************************************************************
      Touch fix for devices to mimick hover effects
    ******************************************************************/
    $("*")
      .on("touchstart", function () {
        $(this).trigger("hover");
      })
      .on("touchend", function () {
        $(this).trigger("hover");
      });

    /*****************************************************************
      Opening & closing the various navigation menu buttons
    ******************************************************************/
    $("#menu-btn").click(function (event) {
      if ($("body").hasClass("menu-open")) {
        $(this).removeClass("active");
        $("body").removeClass("menu-open");
      } else {
        $(this).addClass("active");
        $("body").addClass("menu-open");
        $(".content-toggle-contain .content-menu").addClass("active");
        $(".content-toggle-contain .content-form").removeClass("active");
      }
    });

    // Toggle Mobile Sub Menus if has Children
    $(window).on("load", function () {
      if (window.outerWidth < 950) {
        var $subLink = $(".collapse > a"),
          $submenuLink = $(".collapse .sub-menu a");
        $subLink.attr("href", "javascript:void(0)");

        $subLink.on("click", function (e) {
          e.preventDefault();
          $(this).parent().toggleClass("sub-menu-open");
          $(this).next(".sub-menu").slideToggle(200);
        });

        $submenuLink.on("click", function (e) {
          $("#menu-btn").removeClass("active");
        });
      }
    });

    /*****************************************************************
     * Toggle Contact Form and Navigation Menu
     *****************************************************************/
    $("#menu-btn-contact, #footer-contact-cta").click(function (event) {
      if ($("body").hasClass("menu-open")) {
        // $("#menu-btn").removeClass("active");
        // $("body").removeClass("menu-open");
        $(".content-toggle-contain .content-form").addClass("active");
        $(".content-toggle-contain .content-menu").removeClass("active");
      } else {
        $("#menu-btn").addClass("active");
        $("body").addClass("menu-open");
        $(".content-toggle-contain .content-form").addClass("active");
        $(".content-toggle-contain .content-menu").removeClass("active");
      }
    });

    /*****************************************************************
     * Toggle Contact Form and Navigation Menu
     *****************************************************************/
    $("#menu-btn-word").click(function (event) {
      if ($("body").hasClass("menu-open")) {
        $(".content-toggle-contain .content-menu").addClass("active");
        $(".content-toggle-contain .content-form").removeClass("active");
      } else {
        $("#menu-btn").addClass("active");
        $("body").addClass("menu-open");
        $(".content-toggle-contain .content-menu").addClass("active");
        $(".content-toggle-contain .content-form").removeClass("active");
      }
    });
  }); // end .ready()
})(jQuery);
// Anything above this line runs only one time on first page load

jQuery(document).on("page.ready", function () {
  // Anything below this line runs after every ajax page load
  $ = jQuery;
  var inHeight = window.innerHeight / 100;
  document.documentElement.style.setProperty("--vh", inHeight + "px");

  var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

  /*****************************************************************
   * Splittin JS Animations
   *****************************************************************/
  Splitting();

  // Splitting additional wrapping words
  $(".line-reveal .word").each(function (index, el) {
    $(el).wrapInner('<span class="new"></span>');
  });

  /*****************************************************************
   * New Parallax - Enabled on Mobile
   *****************************************************************/
  $("[data-parallax]").parallax({
    enableTouchDevices: true,
  });

  /*****************************************************************
  // Check Page for Light or Dark Mode on Nav and Logo items
  *****************************************************************/
  if ($("main.about, main.etf, main.insights-overview").length) {
    $("body").addClass("dark-mode");
  } else {
    $("body").removeClass("dark-mode");
  }

  /*****************************************************************
  // Smooth Scroll on Page
  *****************************************************************/
  $('a[href^="#"]').on("click", function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;

      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top + 1,
        },
        800,
        function () {
          window.location.hash = hash;
        }
      );
    }
  });

  // Scroll to Section - No hash added to URL - Use class or id i.e. ".this-sectoon"
  $("[data-scroll-to]").on("click", function (event) {
    event.preventDefault();
    var hash = $(this).attr("data-scroll-to"),
      offset = $(this).attr("data-offset") || 0,
      hashSection;

    if ($(this).attr("data-scroll-to")) {
      hashSection = $(hash);
    } else {
      hashSection = $(this).parents("section").next();
    }

    $("html, body").animate(
      {
        scrollTop: hashSection.offset().top + offset,
      },
      800,
      function () {
        // window.location.hash = hash;
      }
    );
  });

  /******************************************************************************************************
    Movetic Stamp
  *******************************************************************************************************/
  $("#mvtc").replaceWith('<a href="https://themovetic.com/" target="_blank" class="mvtc text--gray btntype">Site by <span>Movetic</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 190" width="9" height="19" style="display: inline-block;vertical-align: middle;"><g><g><polygon points="41.82 0 87.27 0 55.45 71.82 90 71.82 10.91 190 35.45 98.18 0 98.18 41.82 0"/></g></g></svg></a>');

  /*****************************************************************
    For when we do a img src="example.svg" SVG use instead of the 
    <svg> html markup
  ******************************************************************/
  $("img.svg").each(function () {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");
    var dataFill = $img.attr("data-fill-color");
    var dataStroke = $img.attr("data-stroke-color");
    $.get(
      imgURL,
      function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find("svg"),
          $svgElements = $(data).find("svg *");
        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        if ($img.parent(".svg-egg").length) {
          // console.log('Easter Egg.');
          $svgElements = $svgElements.removeAttr("stroke");
        }
        // Add Fill color of SVG
        if (typeof dataFill !== "undefined") {
          $svg = $svg.attr("fill", dataFill);
        }

        // Add Stroke color of SVG
        if (typeof dataStroke !== "undefined") {
          $svg = $svg.attr("stroke", dataStroke);
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (!$svg.attr("viewBox") && $svg.attr("height") && $svg.attr("width")) {
          $svg.attr("viewBox", "0 0 " + $svg.attr("height") + " " + $svg.attr("width"));
        }
        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      "xml"
    );
  });

  /*****************************************************************
   * Image Wipes
   *****************************************************************/
  // Debounce Concept
  var doit;
  $(window).on("resize", function () {
    clearTimeout(doit);
    doit = setTimeout(runImgWipe, 1000);
  });

  function runImgWipe() {
    $(".img-wipe").each(function (i, e) {
      var imgWidth = $(e).find("img").outerWidth(),
        imgHeight = $(e).find("img").outerHeight();
      $(e).css({width: imgWidth + "px", height: imgHeight + "px"});
    });
  }

  Promise.all(
    Array.from(document.images)
      .filter((img) => !img.complete)
      .map(
        (img) =>
          new Promise((resolve) => {
            img.onload = img.onerror = resolve;
          })
      )
  ).then(() => {
    // console.log("imgload");
    runImgWipe(); // Run on Load
    // console.log("runImgWipe");
  });

  /*****************************************************************
    Lazy Load Assets
  ******************************************************************/
  var images = document.querySelectorAll("img[data-msrc]");
  var config = {
    rootMargin: "5% 5% 5% 5%",
    threshold: 0,
  };

  var observer;

  if ("IntersectionObserver" in window) {
    observer = new IntersectionObserver(onChange, config);
    images.forEach(function (img) {
      return observer.observe(img);
    });
  } else {
    // console.log("%cIntersection Observers not supported", "color: red");
    // images.forEach((image) => loadImage(image));
    images.forEach(function (image) {
      return loadImage(image);
    });
  }

  var loadImage = function (image) {
    image.classList.add("fader-in");
    image.src = image.dataset.msrc;
  };

  function onChange(changes, observer) {
    changes.forEach(function (change) {
      if (change.intersectionRatio > 0) {
        // Stop watching and load the image
        loadImage(change.target);
        observer.unobserve(change.target);
      }
    });
  }

  /******************************************************************************************************
    Detect Scroll Direction
  *******************************************************************************************************/
  var lastScrollTop = 0;
  window.addEventListener(
    "scroll",
    function () {
      var st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop) {
        $("body").addClass("scroll-down");
        $("body").removeClass("scroll-up");
      } else {
        $("body").removeClass("scroll-down");
        $("body").addClass("scroll-up");
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    },
    false
  );

  // Remove at top of page
  var $window = $(window);

  $window.scroll(function () {
    if ($window.scrollTop() < 25) {
      $("body").removeClass("scroll-up");
    }
  });

  /*****************************************************************
      Animation Library / Area.
      Scroll Magic + GSAP
    ******************************************************************/
  // init scroll magic
  var smcontroller = new ScrollMagic.Controller();
  $(".fade-in-up").each(function () {
    var me = $(this);
    var showFromBot = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.95,
    })
      .on("start", function (event) {
        $(me).addClass("show");
      })
      //.addIndicators()
      .addTo(smcontroller);
  });

  $(".fade-in").each(function () {
    var me = $(this);
    var showFromBot = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.95,
    })
      .on("start", function (event) {
        $(me).addClass("show");
      })
      //.addIndicators()
      .addTo(smcontroller);
  });

  $(".fade-in-left").each(function () {
    var me = $(this);
    var showFromBot = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.95,
    })
      .on("start", function (event) {
        $(me).addClass("show");
      })
      //.addIndicators()
      .addTo(smcontroller);
  });

  $(".fade-in-right").each(function () {
    var me = $(this);
    var showFromBot = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.95,
    })
      .on("start", function (event) {
        $(me).addClass("show");
      })
      //.addIndicators()
      .addTo(smcontroller);
  });

  $(".line-reveal, .char-reveal").each(function () {
    var me = $(this);
    var lineReveal = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.95,
    })
      .on("start", function (event) {
        $(me).addClass("show");
      })
      // .addIndicators()
      .addTo(smcontroller);
  });

  $(".scroll-custom").each(function () {
    var me = $(this);
    var showFromBot = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.95,
    })
      .on("start", function (event) {
        $(me).addClass("show");
      })
      //.addIndicators()
      .addTo(smcontroller);
  });

  $(".scroll-custom-reversed").each(function () {
    var me = $(this);
    var showFromBot = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.75,
    })
      .on("start", function (event) {
        $(me).toggleClass("show");
      })
      // .addIndicators()
      .addTo(smcontroller);
  });

  /*****************************************************************
   * Klaviyo form integration
   *****************************************************************/
  // function KlaviyoSubscribe(listID, email, source) {
  //   var subscribed = false;
  //   $.ajax({
  //     type: "POST",
  //     url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
  //     data: {
  //       g: listID,
  //       email: email,
  //       //pass in additional fields
  //       //$fields: "$source, $first_name, $last_name",
  //       $source: source,
  //     },
  //     contentType: "application/x-www-form-urlencoded",
  //     error: function (err) {
  //       console.log("Could not connect to Klaviyo.");
  //       console.log(err);
  //     },
  //     success: function (res) {
  //       console.log("success");
  //       console.log(res);
  //       subscribed = true;

  //       if (res.data.is_subscribed == false) {
  //         var msg = "<p>Email added successfully. Check email for verification.</p>";

  //         $("#klaviyo-holder").addClass("success");
  //         $("#klaviyo-message").addClass("success");
  //         $("#klaviyo-message").html(msg);
  //       }

  //       if (res.data.is_subscribed == true) {
  //         var msg = "<p>That email is already subscribed to our list. Please use another.</p>";
  //         // $("#klaviyo-holder").addClass("success");
  //         $("#klaviyo-message").addClass("success");
  //         $("#klaviyo-message").html(msg);
  //       }
  //     },
  //     async: false,
  //   });
  //   return subscribed;
  // }

  // $("#subscribe-to-newsletter").click(function (event) {
  //   event.preventDefault();
  //   const listID = "VrSkiD"; // New Subscribers
  //   const email = $("#klaviyo-email").val();
  //   const source = "Sign Up Form";
  //   var re = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$");

  //   if (email != "" && re.test(email)) {
  //     KlaviyoSubscribe(listID, email, source);
  //   } else {
  //     // do nothing
  //     alert("Enter valid email.");
  //   }
  // });

  /*****************************************************************
    Top Banner
  ******************************************************************/
  var $siteLogo = $("body.home .sitelogo"),
    $menuContainer = $("body .menu-container");

  setTimeout(function () {
    $siteLogo.css("opacity", 1);
    $menuContainer.css("opacity", 1);
  }, 500);

  if ($("#banner-notice").length) {
    var bannerInit = function () {
      var $banner = $("#banner-notice"),
        $siteLogo = $("body >.sitelogo"),
        $menuContainer = $("body > .menu-container"),
        bannerHeight = $banner.height();

      $siteLogo.css("margin-top", bannerHeight + "px");
      $menuContainer.css({top: bannerHeight, position: "absolute"});

      $("body").css("margin-top", bannerHeight + "px");

      $(window).scroll(function () {
        if ($(window).scrollTop() > bannerHeight) {
          // $("body").css("margin-top", 0 + "px");
          // $siteLogo.css("margin-top", 0 + "px");
          $menuContainer.css({top: 0, position: "fixed"});
        } else {
          $("body").css("margin-top", bannerHeight + "px");
          $siteLogo.css("margin-top", bannerHeight + "px");
          $menuContainer.css({top: bannerHeight, position: "absolute"});
        }
      });
    };

    bannerInit();

    window.addEventListener(
      "resize",
      debounce(function (e) {
        bannerInit();
      })
    );

    function debounce(func) {
      var timer;
      return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 100, event);
      };
    }
  }

  // if ($("body").hasClass("logged-in")) {
  //   $("html").attr("style", "margin-top: 0 !important");
  // }

  /*****************************************************************
    Form Reveal Captcha
  ******************************************************************/
  $("form").each(function (index, el) {
    $(el)
      .find("input,textarea")
      .on("focus", function () {
        $(el).find(".toggle-field").addClass("toggle-field--active");
      });

    // $(el)
    //   .find("input,textarea")
    //   .on("blur", function () {
    //     $(el).find(".toggle-field").removeClass("toggle-field--active");
    //   });
  });

  /*****************************************************************
      Cookies for Privacy Policy
    ******************************************************************/
  var Cookie = {
    Create: function (name, value, days) {
      var expires = "";

      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
      }

      document.cookie = name + "=" + value + expires + "; path=/";
    },
    Read: function (name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    Erase: function (name) {
      Cookie.create(name, "", -1);
    },
  };
  var cookiePolicyAgree = Cookie.Read("policyagreed") == 1;
  if (!cookiePolicyAgree) {
    $("#cookies-notice button").click(function (event) {
      $("#cookies-notice").css("display", "none");

      Cookie.Create("policyagreed", "1", 7);
    });
  } else {
    // User has already told us they are of age
    $("#cookies-notice").css("display", "none");
  }
  /*****************************************************************
        END Cookies for Age Gate
      ******************************************************************/

  /*****************************************************************
    Setup Cookies for 21 and Over
  ******************************************************************/
  // var movementStrength = 15;
  // var height = movementStrength / $(window).height();
  // var width = movementStrength / $(window).width();
  // $(window).mousemove(function (e) {
  //   var pageX = e.pageX - $(window).width() / 2;
  //   var pageY = e.pageY - $(window).height() / 2;
  //   var newvalueX = width * pageX * -1 - 100;
  //   var newvalueY = height * pageY * -1 - 50;
  //   $(".legals").css("background-position", newvalueX + "px     " + newvalueY + "px");
  // });

  // var legals = $(".legals");
  // window.isLegal = !1;

  // window.hideLegals = function () {
  //   window.isLegal = !0;
  //   legals.remove();
  //   $("body").removeClass("legals-active");
  //   // document.cookie = "legal=true";
  //   setCookie("legal", "true", 1);
  // };

  // window.illegal = function () {
  //   alert("Oh, well comeback when you are... ");
  //   window.location.replace("https://google.com");
  // };

  // if ("true" == getCookie("legal")) {
  //   window.hideLegals();
  // } else {
  //   $("body").addClass("legals-active");
  //   legals.css("visibility", "visible");
  // }

  // $(".legals-yes").click(function () {
  //   window.hideLegals();
  // });

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
});
